import { useTranslation } from 'react-i18next'
import { ScreeningInsightsResponse } from '@estercare/ester-shared'
import { theme } from '../../../../theme/theme'
import { ChartCard } from '../../../charts/ChartCard'
import { BarChartComponent } from '../../../charts/BarChartComponent'
import { buildTicks } from '../../../charts/shared'
import { ChartData } from '../../../charts/type'
import { NotEnoughScreeningData } from '../../../charts/NotEnoughData'

type Props = {
  /** Absent when the API suppressed the chart. The band count varies, so read `label`. */
  data?: NonNullable<ScreeningInsightsResponse['ageDistribution']>
  chartWidth?: number
  chartHeight?: number
  chartAnimated?: boolean
}

export const AgeDistributionCard = ({ data, chartWidth, chartHeight = 240, chartAnimated }: Props) => {
  const { t } = useTranslation()

  const peakCount = data ? Math.max(...data.bands.map(({ count }) => count)) : 0
  const chartData: ChartData[] =
    data?.bands.map(({ label, count }) => ({
      name: label,
      value: count,
      color: count === peakCount ? theme.color.plum : theme.color.mauve,
    })) ?? []

  return (
    <ChartCard
      title={t('admin.statistics.ageDistributionTitle')}
      caption={t('admin.statistics.ageDistributionCaption')}
    >
      {chartData.length > 0 ? (
        <BarChartComponent
          height={chartHeight}
          barRadius={6}
          width={chartWidth}
          animated={chartAnimated}
          data={chartData}
          ticks={buildTicks(peakCount)}
        />
      ) : (
        <NotEnoughScreeningData />
      )}
    </ChartCard>
  )
}
